import { useContext, useEffect } from 'react';

import { useQuery as useApolloQuery } from '@apollo/client';

import UFOInteractionContext from '@atlaskit/react-ufo/interaction-context';

import getOperationName from '../utils/get-operation-name';

export const useQuery: typeof useApolloQuery = (...args) => {
	const ufoContext = useContext(UFOInteractionContext);

	const apolloResult = useApolloQuery(...args);

	const [query] = args;
	const operationName = getOperationName(query);

	const isLoading = apolloResult?.loading;

	useEffect(() => {
		if (isLoading) {
			return ufoContext?.hold(operationName);
		}
	}, [isLoading, operationName, ufoContext]);

	return apolloResult;
};
